import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';

const DeleteVoiceAssistantModal = ({ open, onClose, onDelete, config }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      if (onDelete) await onDelete();
      onClose();
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const assistantName = config?.persona?.assistant_name || 'this voice assistant';
  const slug          = config?.voice_slug || '';
  const phoneNumber   = config?.integrations?.connect_phone_number || '';
  const instanceId    = config?.integrations?.connect_instance_id || '';

  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Confirm Deletion</ModalHeader>

      <ModalBody>
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
          <div style={{ width: 42, height: 42, borderRadius: 10, background: '#FEF2F2', border: '1px solid #FECACA', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
            ⚠️
          </div>
          <div>
            <p style={{ margin: '0 0 8px', fontWeight: 600, color: '#0F172A' }}>
              Delete <strong>{assistantName}</strong>
              {slug && <> (<code style={{ fontSize: 12 }}>{slug}</code>)</>}?
            </p>
            {phoneNumber && (
              <p style={{ margin: '0 0 8px', fontSize: 13, color: '#64748B' }}>
                📞 AWS Connect number <strong>{phoneNumber}</strong> will stop routing to this assistant immediately.
              </p>
            )}
            {instanceId && (
              <p style={{ margin: '0 0 8px', fontSize: 13, color: '#64748B' }}>
                ☁️ Connect instance <code style={{ fontSize: 11 }}>{instanceId.slice(0, 18)}…</code> will be disassociated.
              </p>
            )}
            <p style={{ margin: 0, fontSize: 12, color: '#94A3B8' }}>
              This action cannot be undone. All call sessions and leads linked to this config will remain in the database but will no longer be associated with an active assistant.
            </p>
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button outline color="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button color="danger" onClick={handleConfirm} disabled={loading} style={{ minWidth: 120 }}>
          {loading && <Spinner size="sm" className="me-2" />}
          {loading ? 'Deleting…' : 'Delete Assistant'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { DeleteVoiceAssistantModal };   